import { createHttpHeaderWithAuthorization } from "../../services/http-header";
import { callWithRetry } from "../../services/callWithRetry";
import { API_PRECOG_URL_V1 } from "../../../config";

export const precogAccountingConstants = {
  GET_DASHBOARD_DATA_START: "GET_DASHBOARD_DATA_START",
  GET_DASHBOARD_DATA_SUCCESS: "GET_DASHBOARD_DATA_SUCCESS",
  GET_DASHBOARD_DATA_ERROR: "GET_DASHBOARD_DATA_ERROR",
  GET_ACCOUNTING_CODES_START: "GET_ACCOUNTING_CODES_START",
  GET_ACCOUNTING_CODES_SUCCESS: "GET_ACCOUNTING_CODES_SUCCESS",
  GET_ACCOUNTING_CODES_ERROR: "GET_ACCOUNTING_CODES_ERROR",
  SAVE_FILTER: "SAVE_FILTER"
};

export function getDashboardData(
  nextUrl, categories, docNumber, accountCode, includesFilter, isActiveValue, dateFrom, dateTo, uuidCurrentFilter, confirmed
) {
  return (dispatch, getState) => {
    // salvo i filtri su redux
    dispatch({
      type: precogAccountingConstants.SAVE_FILTER,
      payload: {
        categories: categories, 
        docNumber: docNumber,
        accountCode: accountCode, 
        includesFilter: includesFilter, 
        isActiveValue: isActiveValue, 
        dateFrom: dateFrom, 
        dateTo: dateTo, 
        uuidCurrentFilter: uuidCurrentFilter
      }
    });

    const auth = getState().auth;
    const managerId = getState().main.accountantUuidSelected;
    const itemId = getState().main.companyUuidSelected;
        
    let url = nextUrl ? nextUrl :     
      `${API_PRECOG_URL_V1}/precog/dashboard-paginated?itemId=${itemId}&managerId=${managerId}&confirmed=${confirmed}${categories?.length > 0 ? "&category=" + categories : ""}${docNumber ? "&docNumber=" + encodeURIComponent(docNumber) : ""}${accountCode ? "&accountCode=" + accountCode : ""}${includesFilter ? "&includes=" + includesFilter : ""}${isActiveValue !== null ? "&isActive=" + isActiveValue : ""}${ dateFrom ? "&dateFrom=" + dateFrom : ""}${dateTo ? "&dateTo=" + dateTo : ""}`;

    return new Promise((resolve, reject) => {
      let request = {
        method: "GET",
        url: url,
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)        
        }
      };

      dispatch({
        type: precogAccountingConstants.GET_DASHBOARD_DATA_START
      });

      callWithRetry(
        auth, request, dispatch
      )
        .then(async(result) => {
          if (result.status === 200 || result.status === 202) {
            // se è l'ultimo filtro eseguito allora salvo i dati in redux altrimenti c'è una chiamata successiva
            // attendo quella
            if (getState().precog?.dashboardFilter?.uuidCurrentFilter === uuidCurrentFilter){
              dispatch({
                type: precogAccountingConstants.GET_DASHBOARD_DATA_SUCCESS,
                payload: {...result, toAdded: nextUrl ? true : false}
              });
              resolve(result);
            } else {
              resolve(result);
            }
          } else {
            dispatch({
              type: precogAccountingConstants.GET_DASHBOARD_DATA_ERROR,
              error: result
            });
            reject();
          }
        })
        .catch((response) => {
          dispatch({
            type: precogAccountingConstants.GET_DASHBOARD_DATA_ERROR,
            error: response
          });
          reject();
        });
    });
  };
}

/* DEPRECATED
export function getDashboardData(
  nextUrl, categories, docNumber, accountCode, includesFilter, isActiveValue, dateFrom, dateTo
) {
  return (dispatch, getState) => {
    const auth = getState().auth;
    const managerId = getState().main.accountantUuidSelected;
    const itemId = getState().main.companyUuidSelected;
    let url = nextUrl ? nextUrl : 
      `${API_PDC_URL_V1}/precog/dashboard?itemId=${itemId}&managerId=${managerId}&confirmed=false${categories.length > 0 ? "&category=" + categories : ""}${docNumber ? "&docNumber=" + docNumber : ""}${accountCode ? "&accountCode=" + accountCode : ""}${includesFilter ? "&includes=" + includesFilter : ""}${isActiveValue !== null ? "&isActive=" + isActiveValue : ""}${dateFrom !== null ? "&dateFrom=" + dateFrom : ""}${dateTo !== null ? "&dateTo=" + dateTo : ""}`;

    return new Promise((resolve, reject) => {
      let request = {
        method: "GET",
        url: url,
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
        }
      };

      dispatch({
        type: precogAccountingConstants.GET_DASHBOARD_DATA_START
      });

      callWithRetry(
        auth, request, dispatch
      )
        .then(async(result) => {
          if (result.status === 200 || result.status === 202) {
            dispatch({
              type: precogAccountingConstants.GET_DASHBOARD_DATA_SUCCESS,
              payload: result
            });
            resolve(result);
          } else {
            dispatch({
              type: precogAccountingConstants.GET_DASHBOARD_DATA_ERROR,
              error: result
            });
            reject();
          }
        })
        .catch((response) => {
          dispatch({
            type: precogAccountingConstants.GET_DASHBOARD_DATA_ERROR,
            error: response
          });
          reject();
        });
    });
  };
}
*/

export function getAccountingCodes() {
  return (dispatch, getState) => {
    dispatch({
      type: precogAccountingConstants.GET_ACCOUNTING_CODES_START
    });
    const auth = getState().auth;
    const managerId = getState().main.accountantUuidSelected;
    const itemId = getState().main.companyUuidSelected;
    let url = `${API_PRECOG_URL_V1}/accounting/bank-accounts?itemId=${itemId}&managerId=${managerId}`;

    return new Promise((resolve, reject) => {
      let request = {
        method: "GET",
        url: url,
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
        }
      };
     
      callWithRetry(
        auth, request, dispatch
      )
        .then(async(result) => {
          if (result.status === 200 || result.status === 202) {
            dispatch({
              type: precogAccountingConstants.GET_ACCOUNTING_CODES_SUCCESS,
              payload: result
            });
            resolve(result);
          } else {
            dispatch({
              type: precogAccountingConstants.GET_ACCOUNTING_CODES_ERROR,
              error: result
            });
            reject();
          }
        })
        .catch((response) => {
          dispatch({
            type: precogAccountingConstants.GET_ACCOUNTING_CODES_ERROR,
            error: response
          });
          reject();
        });
    });
  };
}
